"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dialogReducer = void 0;
var tslib_1 = require("tslib");
var dialogReducer = function (dialogs, action) {
    var dialogId = action.dialogId, isOpen = action.isOpen;
    if (isOpen) {
        if (dialogs.find(function (dialog) { return dialog.id === dialogId; })) {
            return tslib_1.__spreadArray([], tslib_1.__read(dialogs), false);
        }
        else {
            return tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(dialogs), false), [{ id: action.dialogId, key: action.key }], false);
        }
    }
    return dialogs.filter(function (dialog) { return dialog.id !== dialogId; });
};
exports.dialogReducer = dialogReducer;
//# sourceMappingURL=dialogs-reducer.js.map